import { Col, Row, Container } from 'react-bootstrap';
import React, { Children, useId } from 'react';

import Vector from "../../assets/images/Vector.png";
//import xyz from "../../assets/images/Vector.png"
import Group from "../../assets/images/Group.png";
import { Image } from 'antd';
interface Ourstoryprops {
    children?: any
    classname?:any
}
export const OurStorySec: React.FunctionComponent<Ourstoryprops> = (props) => {
    // const pageId1 = useId() 
    return (
        <Container fluid className='shpbgcontainer py-4' 
        style={{background:'white'}}>
            <img src={Vector} alt="" className='bgshaps shpbg1'/>
            <Container className={props.classname} >
                {props.children}
            </Container >
            <img src={Group} alt="" className='bgshaps  shpbg2' />
        </Container >
    )
}

export default OurStorySec;